import { render, staticRenderFns } from "./Enemy.vue?vue&type=template&id=12f6a2ff&scoped=true&"
import script from "./Enemy.vue?vue&type=script&lang=js&"
export * from "./Enemy.vue?vue&type=script&lang=js&"
import style0 from "./Enemy.vue?vue&type=style&index=0&id=12f6a2ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f6a2ff",
  null
  
)

export default component.exports